module.exports = __webpack_public_path__ + "img/brown-carpet-grass-05.d3c6bdcf.png";